import React, { useContext, useEffect } from 'react';
import InitialsAvatar from './InitialsAvatar';
import { AdminUsersContext } from '../../Contexts';

interface UserAvatarCellProps {
    userId?: number;
}

// Shared "created by / modified by" cell for Post/Gallery/File/Image tables. Resolves the
// name from AdminUsersContext; shows a dash while there's no id or the context hasn't loaded.
const UserAvatarCell: React.FC<UserAvatarCellProps> = ({ userId }) => {
    const { adminUserNames, loaded, refreshAdminUsers } = useContext(AdminUsersContext);
    const name = userId ? adminUserNames.get(userId) : undefined;

    useEffect(() => {
        if (!userId || !loaded || name !== undefined) {
            return;
        }
        // Not in the list we loaded - e.g. the admin is newly registered 
        // Refetch the full list;
        refreshAdminUsers();
    }, [userId, loaded, name]);

    if (!userId || !loaded) {
        return <span className="st-cell-dash">—</span>;
    }

    return <InitialsAvatar name={name ?? 'Neznámy používateľ'} id={userId} unknown={name === undefined} />;
};

export default UserAvatarCell;
